var exports = {
  "Bd": "x61f99309--93f2f5--pages",
  "RC": "x61f99309--93f2f5--preloader",
  "me": "x61f99309--93f2f5--separator",
};

module.exports = exports;
